import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { showModal } from 'actions/common'
import { GRID_DATES_MODAL } from 'constants/modal-constants'

import GridHeaderCorner from './grid-header-corner'

class GridHeaderCornerContainer extends Component {

  constructor(props) {
    super(props)

    this.showNewDatesModal = this.showNewDatesModal.bind(this)
  }

  showNewDatesModal() {
    this.props.showModal(GRID_DATES_MODAL)
  }

  render() {
    return (
      <GridHeaderCorner {...this.props} showNewDatesModal={this.showNewDatesModal} />
    )
  }
}

GridHeaderCornerContainer.propTypes = {
  showModal: PropTypes.func.isRequired,
}

const mapDispatchToProps = { showModal }

export default connect(undefined, mapDispatchToProps)(GridHeaderCornerContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-header-corner/grid-header-corner-container.js
 **/